import clsx from 'clsx'
import { Badge } from '../../components/ui'
import { shortDate } from '../../lib/format'
import type { Row } from './plan'

/**
 * The small marks beside a task's title: pinned dates, a hand-placed row, a deadline.
 *
 * IT SHOWS THESE, AND NOTHING IN THE APP SETS THEM ANY MORE. The panel that did — "when it can
 * happen", with its constraints, deadline, task type and scheduling mode — is gone, because it
 * was a second scheduling vocabulary sitting on top of the dates people actually use, and
 * nobody was using it. What could still put these on a row is a plan imported from Microsoft
 * Project, which carries all of it; a plan that arrives with a pinned date should say so rather
 * than quietly ignoring it.
 *
 * Lifted out of `Rules.tsx` when that file went, because this half earns its place and the rest
 * did not.
 */
export function RuleMarks({ row }: { row: Row }) {
  const pinned = row.constraint_type === 'mso' || row.constraint_type === 'mfo'
  const constrained = row.constraint_type && row.constraint_type !== 'asap'
  const manual = row.scheduling_mode === 'manual'
  if (!constrained && !row.deadline_on && !manual) return null
  return (
    <span className="flex shrink-0 items-center gap-1">
      {manual && (
        <span
          title="Somebody decided these dates. The plan settles around it rather than moving it."
          className="text-[10px] leading-none text-[var(--color-accent)]"
        >
          ✋
        </span>
      )}
      {constrained && (
        <span
          title={`${row.constraint_label} ${row.constraint_on ? shortDate(row.constraint_on) : ''}`}
          className={clsx(
            'text-[10px] leading-none',
            pinned ? 'text-[var(--color-accent)]' : 'text-[var(--color-ink-faint)]',
          )}
        >
          {pinned ? '📌' : '⟐'}
        </span>
      )}
      {row.deadline_on && (
        <Badge tone={row.past_deadline_by ? 'danger' : 'neutral'}>
          {row.past_deadline_by ? `${row.past_deadline_by}d late` : shortDate(row.deadline_on)}
        </Badge>
      )}
    </span>
  )
}
